import { createStore } from "../../Boilerplate/NBoilerplateContext";
import { setGlobalStoreInstance } from "../../Boilerplate/store";

// UI preferences persisted per-user via localStorage (zustand persist).
// sortMode controls the candidate list ordering ("recent" | "alpha").
// nameFormat controls how candidate names render ("firstLast" | "lastFirst").
// homePage controls which page "/" lands on: "auto" = the plan default (the activity
//   feed when the tenant has collaboration, else contacts), or a specific page key.
// hideActivity removes the Activity feed from the nav entirely — a per-user opt-out
//   for people who don't want it; the tenant still has the feature.
const appState = (set) => ({
  sortMode: "recent",
  setSortMode: (mode) => set(() => ({ sortMode: mode })),
  nameFormat: "firstLast",
  setNameFormat: (fmt) => set(() => ({ nameFormat: fmt })),
  // candidatesView controls the /candidates presentation ("list" | "map").
  candidatesView: "list",
  setCandidatesView: (v) => set(() => ({ candidatesView: v })),
  homePage: "auto",
  setHomePage: (p) => set(() => ({ homePage: p })),
  hideActivity: false,
  setHideActivity: (v) => set(() => ({ hideActivity: v })),
  // Plan entitlements (plan, feature flags, limits+usage, credit balance).
  // Persisted as a cache so plan-gating (usePlan) — e.g. the Activity nav item — is known
  // synchronously on boot and doesn't flash in after an async fetch; still refreshed from
  // GET /entitlements on mount, so a stale cached value self-corrects within a tick.
  entitlements: null,
  setEntitlements: (e) => set(() => ({ entitlements: e })),
  // Unread tenant-activity-feed count for the nav badge (Pro+). Not persisted — refetched.
  feedUnread: 0,
  setFeedUnread: (n) => set(() => ({ feedUnread: n })),
  // Count of the current user's overdue + due-today tasks for the Tasks nav badge. Not persisted.
  taskNavBadge: 0,
  setTaskNavBadge: (n) => set(() => ({ taskNavBadge: n })),
  // Unread in-app notification count for the header bell. Not persisted — polled.
  notifUnread: 0,
  setNotifUnread: (n) => set(() => ({ notifUnread: n })),
});
appState.partialize = (state) => ({
  sortMode: state.sortMode,
  nameFormat: state.nameFormat,
  candidatesView: state.candidatesView,
  homePage: state.homePage,
  hideActivity: state.hideActivity,
  entitlements: state.entitlements,
});

export const store = createStore({
  name: "veft",
  appState,
});

setGlobalStoreInstance(store);

export const useStore = store;
